export enum StatsInterval {
    TODAY = 'TODAY',
    SEVEN_DAYS = 'SEVEN_DAYS',
    THIRTY_DAYS = 'THIRTY_DAYS',
    NINETY_DAYS = 'NINETY_DAYS'
}

export default StatsInterval;